export interface ErreurValidationModel {
  codeErreur: string;
  prenomCoemprunteur?: string;
  typePreautorisation?: string;
}

export enum ErreurPreautCoemprunteur {
  Annule = 'PREAUT_ANNULEE',
  Invalide = 'CODE_INVALIDE',
  CodeCourrielInvalide = 'CODE_ET_COURRIEL_INVALIDE',
  Expire = 'CODE_EXPIRE',
  ProjetInvalide = 'PROJET_INVALIDE',
  InstitutionInvalide = 'INSTITUTION_INVALIDE'
}
